module.exports = __webpack_public_path__ + "img/Brasil.500dec39.png";